<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("rankingDeServicos") }}
        </h1>
      </div>
    </div>
    <VisionFourCharts />
  </div>
</template>

<script>
import VisionFourCharts from './components/VisionFourCharts.vue';

export default {
  components: { VisionFourCharts },
};
</script>
